import React from "react";
import InstockIcon from "../components/Icons/Instock";
import BuyOrHireIcon from "../components/Icons/BuyOrHire";
import styled, { css } from "styled-components";
import { HtmlContent } from "./Content";

const BadgesStyles = styled.ul`
  ${({ ...props }) => css`
    display: flex;
    flex-wrap: wrap;
    gap: 16px 24px;

    li {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      text-align: center;

      svg,
      img {
        margin-bottom: 16px;
      }
    }

    .title {
      max-width: 100px;
      min-height: 40px;
    }

    @media (min-width: ${props.theme.breakpoints.lg}) {
      .badge--3 {
        max-width: 90px;
      }
    }
  `}
`;

export const ProductBadges = ({productMeta}) => {
  return (
    <BadgesStyles className="product_badges">
      {!productMeta.hideBuyOrHireBadge && (
        <li>
          <BuyOrHireIcon />
        </li>
      )}
      {productMeta.stackStatus && (
        <li>
          <InstockIcon />
          <span className="title">In-stock</span>
        </li>
      )}
      {productMeta.badges &&
      productMeta.badges.length > 0
        ? productMeta.badges.map((badge) => {
            return (
              <li
                key={badge.badge.title}
                className={`badge--${productMeta.badges.length}`}
              >
                {badge.badge.productBadges.icon && (
                  <span>
                    <HtmlContent htmlString={badge.badge.productBadges.icon} />
                  </span>
                )}
                <span className="title">
                  {badge.badge.title}
                </span>
              </li>
            );
          })
        : ""}
    </BadgesStyles>
  );
};
